import React, { useEffect, useState } from 'react';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { Card } from 'reactstrap';
import { CircularProgress, Paper } from '@material-ui/core';
import { SALES_VAT } from '../../../common/charts/chartDataConfig';
import SalesNumbersSummary from './../SalesNumbersSummary';
import DashboardChartWrapper from './../DashboardChartWrapper';
import { getDateRangeString } from '../../../../utils/dates-utils';
import { TranslationsContext } from '../../../../config/translations';
import {
  dayBeforeYesterdaySales,
  lastMonthSales,
  lastWeekSales,
  prevWeekSales,
  thisWeekSales,
  todaySales,
  yesterdaySales,
} from '../DashboardSalesPerDate';
import { clearSalesLastMonth, fetchDashboardSalesLastMonth } from '../../../../actions/dashboard-actions';
import withStyles from '@material-ui/core/styles/withStyles';
import PropTypes from 'prop-types';
import NoDataAvailable from '../../../common/charts/NoDataAvailable';
import { FormattedMessage } from 'react-intl';

const styles = (() => ({
  lastMonthLoading: {
    minHeight: '520px',
    minWidth: '100%',
  },
}));

const SalesLastMonth = (props) => {
  const {
    dashboardReports,
    machines,
    allMachineIDs,
    selectedMachineIds,
    setFetchingStateArray,
    fetchDashboardSalesLastMonth,
    clearSalesLastMonth,
    styles,
    classes,
  } = props;
  const charts = {
    SalesThisMonth: { ...SALES_VAT, labelFields: ['Datum'], time: true },
  };
  
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    if (!isLoading) {
      clearSalesLastMonth();
      fetchDashboardSalesLastMonth(allMachineIDs, selectedMachineIds, setIsLoading, setFetchingStateArray);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchDashboardSalesLastMonth, clearSalesLastMonth, selectedMachineIds]);
  
  if (!dashboardReports || !machines) {
    return <div className={`${styles.loading} ${classes.lastMonthLoading}`}><CircularProgress color="primary" /></div>;
  }
  
  if (dashboardReports?.SalesLastMonth === '') {
    return <NoDataAvailable />;
  }
  
  const recentMonthSales = dashboardReports && lastMonthSales(dashboardReports);
  
  return (
    <TranslationsContext.Consumer>
      {({ languageState }) => (
        <>
          <div className={styles.mainPartWrapper}>
            <Card className="card-chart">
              {!dashboardReports.error &&
              <>
                <SalesNumbersSummary
                  salesThisWeek={thisWeekSales(dashboardReports)}
                  salesLastWeek={lastWeekSales(dashboardReports)}
                  salesPrevWeek={prevWeekSales(dashboardReports)}
                  salesToday={todaySales(dashboardReports)}
                  salesYesterday={yesterdaySales(dashboardReports)}
                  salesBeforeYesterday={dayBeforeYesterdaySales(dashboardReports)}
                  salesLastMonth={lastMonthSales(dashboardReports)}
                />
  
                {recentMonthSales && <Paper className={styles.cardBody}>
                  <div className={styles.contentTitle}>
                    <h3>
                      <FormattedMessage
                        id="page.dashboard.salesLastMonth"
                        defaultMessage="Sales last month"
                      />
                    </h3>
                    {getDateRangeString(lastMonthSales(dashboardReports), languageState)}
                  </div>
                  <DashboardChartWrapper
                    reports={recentMonthSales}
                    chart={charts.SalesThisMonth}
                    languageState={languageState}
                  />
                </Paper>}

              </>}
            </Card>
          </div>
        </>
      )}
    </TranslationsContext.Consumer>);
};

const decorate = compose(
  withStyles(styles),
  connect(
    store => ({
      machines: store.user.machines,
      dashboardReports: store.report.dashboard,
    }),
    dispatch => bindActionCreators({
      fetchDashboardSalesLastMonth,
      clearSalesLastMonth,
    }, dispatch),
  ),
);

SalesLastMonth.propTypes = {
  dashboardReports: PropTypes.object,
  machines: PropTypes.array,
  machine: PropTypes.string,
  fetchDashboardSalesLastMonth: PropTypes.func,
  clearSalesLastMonth: PropTypes.func,
  styles: PropTypes.object,
  classes: PropTypes.object,
};

export default decorate(SalesLastMonth);
